export interface SetRanges {
    min: number;
    max: number;
}

export interface DataPremiumSet{
    allowance: SetRanges;
    budget: SetRanges;
    roomFee: SetRanges;
}

export class PremiumRange implements DataPremiumSet {
    allowance: SetRanges;
    budget: SetRanges;
    roomFee: SetRanges;

    constructor(allowance: SetRanges | null, budget: SetRanges | null, roomFee: SetRanges | null) {
        this.allowance = allowance;
        this.budget = budget;
        this.roomFee = roomFee;
    }


    get hiddenAllowance(): boolean{
        return this.allowance ? true : false;
    }

    get hiddenBudget(): boolean{
        return this.budget ? true : false; 
    }

    get hiddenRoomFee(): boolean{
        return this.roomFee ? true : false;
    }

    get disableAllowace() : boolean{
        return this.allowance.max === this.allowance.min 
    }
    

    get disableBudget() : boolean{
        return this.budget.max === this.budget.min;
    }

    get disableRoomFee() : boolean{
        return this.roomFee.max === this.roomFee.min;
    }

    get minAllowance(): number {
        return this.allowance.max === this.allowance.min ? 0 : Math.ceil(this.allowance.min)
    }

    get minAllowanceActual(): number{
        return this.allowance.max === this.allowance.min ? 0 : this.allowance.min
    }

    get maxAllowance(): number {
        return Math.ceil(this.allowance.max)
    }


    get minBudget(): number {
        return this.budget.max === this.budget.min ? 0 : Math.ceil(this.budget.min)
    }

    get minBudgetActual(): number {
        return this.budget.max === this.budget.min ? 0 : this.budget.min
    }

    get maxBudget(): number {
        return Math.ceil(this.budget.max);
    }

    get minRoomFee(): number {
        return this.roomFee.max === this.roomFee.min ? 0 : Math.floor(this.roomFee.min);
    }

    get minRoomFeeActual(): number {
        return this.roomFee.max === this.roomFee.min ? 0 : this.roomFee.min;
    }

    get maxRoomFee(): number {
        return Math.ceil(this.roomFee.max);
    }

    get maxRoomFeeActual():number {
        return this.roomFee.max
    }


    get fixPositionAllowance(): boolean {
        return this.allowance.max === this.allowance.min
    }

    get fixPositionBudget(): boolean {
        return this.budget.max === this.budget.min
    }

    get fixPositionRoomFee(): boolean {
        return this.roomFee.max === this.roomFee.min
    }


}